module.exports = __webpack_public_path__ + "img/btu-logo.c08447cd.svg";